export const IMAGE_PREVIEW = 'IMAGE_PREVIEW';
